import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import Selection from "./selection";
import Content from "./content";
import Cookies from "universal-cookie";

const Category = (props) => {
  const [anim, setAnim] = useState(true);
  const [selectList, setSelectList] = useState([]);
  const [state, setState] = useState({
    data: [],
    dataNull: false,
    statusCategory: false,
  });
  const cookies = new Cookies()

  useEffect(() => {
    if (cookies.get("api_key") == null) {
      props.history.push("/entrance");
    }
    if (localStorage.getItem("category") == null) {
      setState({
        ...state,
        statusCategory: true,
      });
    } else {
      let temp = {
        id: JSON.parse(localStorage.getItem("category")).id,
        children: JSON.parse(localStorage.getItem("category")).children,
        index: 0,
      };
      if (JSON.parse(localStorage.getItem("category")).children.length == 0) {
        setState({
          ...state,
          dataNull: true,
        });
      }
      setSelectList([temp]);
    }
  }, []);

  const setValue = (value, selectValue) => {
    let selectStatus = false;
    selectList.map((item) => {
      if (value.index == item.index) {
        return (selectStatus = true);
      }
    });

    let tempArry = state.data;
    let temp = [];
    tempArry.map((item) => {
      if (!(selectValue.index == item.index)) {
        temp.push(item);
      }
    });
    setState({
      ...state,
      data: temp,
    });
    temp.push({ name: selectValue.label, index: selectValue.index });

    if (!selectStatus) {
      let tempSelect = selectList;
      tempSelect.push(value);
      setSelectList(tempSelect);
      setAnim(!anim);
    } else if (selectValue.value.length !== 0) {
      let tempArry = [];
      selectList.map((item) => {
        if (value.index > item.index) {
          tempArry.push(item);
        }
      });
      tempArry.push(value);
      setSelectList([]);
      setTimeout(() => {
        setSelectList(tempArry);
      }, 10);
      setAnim(!anim);
    }
    setAnim(!anim);

    if (selectValue.data.children.length == 0) {
      props.history.push(`/education/category/${selectValue.data.id}`);
    }
  };

  return (
    <div className={`category-educ ${anim ? "active" : ""}`}>
      {!state.dataNull ? (
        <div className="contain">
          <div
            className={`row-education ${
              state.statusCategory ? "full-width" : ""
            }`}
          >
            {state.statusCategory ? null : (
              <div className="sub-categorys">
                <h4>دسته بندی</h4>
                <div className="inner-subcategroy">
                  {selectList.length == 0
                    ? null
                    : selectList.map((info, index) => {
                        return (
                          <Selection
                            key={info.id}
                            number={info.index}
                            options={info.children}
                            setValue={setValue}
                            placeholder={
                              state.data.length !== 0 &&
                              index < selectList.length - 1
                                ? state.data.map((item) =>
                                    item.index == info.index ? item.name : null
                                  )
                                : "دسته بندی"
                            }
                          />
                        );
                      })}
                </div>
              </div>
            )}

            <Content />
          </div>
        </div>
      ) : (
        <div className="contain">
          <div className="no-content">
            <img src="/svg/copy.svg" />
            <span>زیر دسته بندی وجود ندارد</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(Category);
